module.exports = __webpack_public_path__ + "static/media/STAF_nynorsk med tjenesteløfte_primærlogo_pos(svart).c433fc7c.png";